export default __webpack_public_path__ + "static/media/service-3.68c94623.jpg";